module.exports = "/wp-content/themes/conversion/public/dist//svgs/modal--conversion-modal-close.svg";